export function onlyDigits(value: string): string {
  return value.replace(/\D+/g, '')
}

export function isInternational(value: string): boolean {
  return value.trim().startsWith('+')
}

export function maskPhone(value: string): string {
  if (isInternational(value)) return '+' + onlyDigits(value).slice(0, 15)
  const digits = onlyDigits(value).slice(0, 11)
  if (digits.length === 0) return ''
  if (digits.length <= 2) return `(${digits}`
  const ddd = digits.slice(0, 2)
  const rest = digits.slice(2)
  const splitAt = digits.length === 11 ? 5 : 4
  if (rest.length <= splitAt) return `(${ddd}) ${rest}`
  return `(${ddd}) ${rest.slice(0, splitAt)}-${rest.slice(splitAt)}`
}

export function normalizePhone(value: string): string {
  if (isInternational(value)) return '+' + onlyDigits(value)
  return onlyDigits(value)
}

export function isValidPhone(value: string): boolean {
  const digits = onlyDigits(value)
  if (isInternational(value)) return digits.length >= 8 && digits.length <= 15
  return (digits.length === 10 || digits.length === 11) && digits[0] !== '0'
}
